/**
 * We need this because for multi-lang jurisdictions, a redirect with lang change can happen before postlogin finishes.
 * To do post-login logic for after lang redirect jurisdiction we need a post-login flag stored
 * in local-storage used to run the logic once after redirects end.
 */

const key = 'isComingFromLangRedirect';
const value = 'true';

export function markComingFromLangRedirect(): void {
    localStorage.setItem(key, value);
}

export function isComingFromLangRedirect(): boolean {
    return localStorage.getItem(key) === value;
}

export function clearComingFromLangRedirect(): void {
    localStorage.removeItem(key);
}
